import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login/login.component';
import { OtpComponent } from './pages/login/otp/otp.component';
import { LayoutComponent } from './pages/layout/layout.component';
import { authGuard } from './guards/auth.guard';
import { roleGuard } from './guards/role.guard';
import { NotFoundComponent } from './pages/shared/not-found/not-found.component';
import { UnauthorizedComponent } from './pages/shared/unauthorized/unauthorized.component';
import { PmsErrorComponent } from './pages/shared/pms-error/pms-error.component';
import { UnderConstructionComponent } from './pages/shared/under-construction/under-construction.component';
import { AdminUserAuthConstants } from './common/admin-auth-constant';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'otp', component: OtpComponent },
  { path: 'verify', component: OtpComponent },
  { path: 'unauthorized', component: UnauthorizedComponent },
  {
    path: '', component: LayoutComponent,
    children: [
      {
        path: 'underconstruction',
        component: UnderConstructionComponent
      },
      { 
        path: 'dashboard',
        loadChildren: () => import('./pages/dashboards/dashboards.module').then(m => m.DashboardsModule),
        // canActivate: [authGuard],
        // data: { permission: AdminUserAuthConstants.Dashboard.DashboardView },
      },
      {
        path: 'verification',
        loadChildren: () => import('./pages/verification/verification.module').then(m => m.VerificationModule),
        // canActivate: [authGuard],
        // data: { permission: [AdminUserAuthConstants.Dashboard.DashboardView] },
      },
      { 
        path: 'pensionermanagement', 
        loadChildren: () => import('./pages/pensionermanagement/pensioner.module').then(m => m.PensionerModule),
      },
      {
        path: 'fosmanagement',
        loadChildren: () => import('./pages/fosmanagement/fosmanagement.module').then(m => m.FosManagementModule),
      },
      { 
        path: 'admin',
        loadChildren: () => import('./pages/adminmanagement/admin.module').then(m => m.AdminModule), 
      },
      {
        path: 'requestmanagement',
        loadChildren: () => import('./pages/requestmanagement/requestmanagement.module').then(m => m.RequestManagement)
      },
      // {
      //   path: 'nomineeverification',
      //   loadChildren: () => import('./pages/nominee-verification/nominee-verification.module').then(m => m.NomineeVerificationModule)
      // },
      {
        path: 'agentmanagement',
        loadChildren: () => import('./pages/agentmanagement/agentmanagement.module').then(m => m.AgentManagementModule)
      },
      {
        path: 'nomineeonly',
        loadChildren: () => import('./pages/nomineeonly/nominee-only.module').then(m => m.NomineeOnlyModule)
      },
      {
        path: 'cashout',
        loadChildren: () => import('./pages/cashoutmanagement/cashoutmanagement.module').then(m => m.CashoutManagementModule)
      },
      {
        path: 'settlement',
        loadChildren: () => import('./pages/settlementmanagement/settlementmanagement.module').then(m => m.SettlementManagementModule)
      },
      {
        path: 'proxyfile',
        loadChildren: () => import('./pages/proxyfileupload/proxyfileupload.module').then(m => m.ProxyFileUploadModule)
      },
      {
        path: 'notification',
        loadChildren: () => import('./pages/notification/notification.module').then(m => m.NotificationModule)
      },
      {
        path: 'transactionreport',
        loadChildren: () => import('./pages/transaction-report/transaction-report.module').then(m => m.TransactionReportModule)
      },
      {
        path: 'fundout',
        loadChildren: () => import('./pages/fundout/fundout.module').then(m => m.FundOutModule)
      },
      {
        path: 'cashouttransaction',
        loadChildren: () => import('./pages/cashouttransaction/cashout-transaction.module').then(m => m.CashoutTransactionModule)
      },
      {
        path: 'pinsinpay',
        loadChildren: () => import('./pages/pinsinpay/pinsinpay.module').then(m => m.PinSinPayModule)
      },
    ]
  },
    { path: '404', component: NotFoundComponent },
    { path: 'error', component: PmsErrorComponent},
    { path: '**', redirectTo: '/404' },
    

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
